import {
  getAppServerSideInfo,
  getOAuth2ChannelNames,
  getAppPublicConfigs
} from '@/api/login.js'

const state = {
  scan_qrcode_login: localStorage.getItem('scanQRCodeLogin') ? (localStorage.getItem('scanQRCodeLogin') === 'true') : false,
  backend: {},
  support: {},
  lastError: {},
  configs: {},
  channel_names: null
}

const mutations = {
  SET_APP: (state, app) => {
    if (app.license_support) {
      const tmpSupport = app.license_support
      delete app.license_support
      state.backend = app
      if (tmpSupport) {
        state.support = tmpSupport
      } else {
        state.support = {}
      }
    } else {
      state.backend = app
      state.support = {}
    }
  },
  SET_CHANNELS: (state, names) => {
    state.channel_names = names
  },
  PUSH_ERROR: (state, error) => {
    state.lastError = error
  },
  SET_CONFIG: (state, configs) => {
    state.configs = configs
  },
  TOGGLE_SCAN_QRCODE_LOGIN: (state) => {
    state.scan_qrcode_login = !state.scan_qrcode_login
    if (state.scan_qrcode_login) {
      localStorage.setItem('scanQRCodeLogin', 'true')
    } else {
      localStorage.setItem('scanQRCodeLogin', 'false')
    }
  }
}

const actions = {

  // 获取应用信息
  loadprofile ({ commit, state }) {
    return new Promise((resolve, reject) => {
      let fetchCount = 3
      const asyncFetched = (error) => {
        if (error) {
          reject(error)
          return
        }
        fetchCount--
        if (fetchCount <= 0) {
          resolve()
        }
      }
      // 加载应用信息
      getAppServerSideInfo(false).then(appinfo => {
        commit('SET_APP', appinfo)
        asyncFetched()
      }).catch(error => {
        asyncFetched(error)
      })
      // 加载全局配置
      getAppPublicConfigs().then(val => {
        commit('SET_CONFIG', val)
        asyncFetched()
      }).catch(error => {
        asyncFetched(error)
      })
      // 加载OAuth2
      getOAuth2ChannelNames(false).then(names => {
        commit('SET_CHANNELS', names)
        asyncFetched()
      }).catch(error => {
        asyncFetched(error)
      })
    })
  },

  pusherror ({ commit, state }, error) {
    return new Promise((resolve, reject) => {
      commit('PUSH_ERROR', error)
      resolve()
    })
  },

  toggleScanQRCodeLogin ({commit}) {
    commit('TOGGLE_SCAN_QRCODE_LOGIN')
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js